import React, { useState } from "react";
import { BiFingerprint, BiMobile, BiX } from "react-icons/bi";
import { MdEmail, MdPerson, MdPersonAdd } from "react-icons/md";
import { RiInstagramFill } from "react-icons/ri";
import api, { rqueryclient } from "src/rest/api";
import Inputfield from "../../../components/inputfield";

import { Student } from "../../student-info";

import { ValidateEmail } from "src/assets/functions";
import InputfieldMask from "src/components/inputfield/inputfieldMask";
import InputPhone from "src/components/inputfield/InputPhone";
import { useDialog } from "src/contexts/dialog-context";
import Step from "./Step";

export interface FoundUser {
  id: string;
  name: string;
  phone: string;
}

const CreateForm: React.FC<{
  onGoBack(): void;
  onAdd: (s: Student) => void;
}> = (props) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    birthdate: "",
    gender: "Male",
    phone: "",
    identity: "",
    username: "",
  });

  const [found, setFound] = useState<FoundUser | undefined>(undefined);
  const [validEmail, setValidEmail] = useState(false);

  async function LocateUser(s: string) {
    setFound(undefined);
    if (s.length < 5 || !ValidateEmail(s)) return;
    await api
      .post("/students/find", { email: s })
      .then((res) => {
        if (res.status === 201) setFound(res.data as FoundUser);
      })
      .catch(() => setFound(undefined));
  }

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;
    if (name === "email") {
      LocateUser(value);
      setValidEmail(ValidateEmail(value));
    }

    setForm({
      ...form,
      [name]: value,
    });
  };

  const handlePhone = (e: string) => {
    setForm({
      ...form,
      phone: e,
    });
  };

  const handleGender = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setForm({
      ...form,
      gender: e.target.value,
    });
  };

  async function Submit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    if (found) {
      api
        .post("/register/link", {
          id: found?.id,
        })
        .then((res) => {
          props.onAdd(res.data as Student);
        })
        .catch((err) => {
          alert(err);
        });
    } else
      await api
        .post("/register/", {
          ...form,
          birthdate: form.birthdate,
        })
        .then((res) => {
          if (res.status === 201) {
            props.onAdd(res.data as Student);
            rqueryclient.invalidateQueries("userinfo");
            //TODO: Adicionar Alerta (hook)
          } else {
            //TODO: Adicionar Alerta (hook)
          }
        })
        .catch((err) => alert(err));
  }

  const diag = useDialog();

  function UnsavedDialog() {
    diag.openDialog(
      "Cancelar Cadastro",
      "O Cadastro atual ainda não foi salvo! Gostaria de cancelar mesmo assim?",
      props.onGoBack,
    );
  }

  return (
    <form
      onSubmit={Submit}
      className="flex h-full w-full flex-col justify-between"
    >
      <p className="text-sm font-semibold">DADOS CADASTRAIS:</p>

      <div className="w-full">
        <Inputfield
          error={true}
          icon={MdEmail}
          width="full"
          hint="Endereço de Email"
          inputProps={{
            name: "email",
            tabIndex: 1,
            onChange: handleInputChange,
            placeholder: "aluno@email.com",
          }}
        />
      </div>

      <Step active={validEmail} found={found}>
        <div className="flex flex-col space-y-4">
          <Inputfield
            inputProps={{
              name: "name",
              onChange: handleInputChange,
              tabIndex: 2,
              placeholder: "Nome",
            }}
            hint="Nome do Aluno"
            minLength={3}
            icon={MdPerson}
          />
          <div className="flex flex-row items-center">
            <Inputfield
              inputProps={{
                type: "date",
                name: "birthdate",
                onChange: handleInputChange,
                tabIndex: 3,
                placeholder: "Nascimento",
                max: new Date().toISOString().split("T")[0],
              }}
              hint="Nascimento:"
            />
            <span className="m-2" />
            <select
              className="mt-[23px] h-[35px] flex-1 rounded border border-zinc-300 focus:outline-none"
              tabIndex={4}
              onChange={handleGender}
            >
              <option disabled>Sexo Biológico</option>
              <option value={"Male"}>♂️ Masculino</option>
              <option value={"Female"}>♀️ Feminino</option>
            </select>
          </div>

          <div className="flex flex-wrap gap-4">
            <InputPhone
              width="w-full md:w-1/2"
              inputProps={{
                name: "phone",
                tabIndex: 5,
                onChange: handleInputChange,
              }}
              icon={BiMobile}
              onChange={handlePhone}
            />
            <InputfieldMask
              width="w-full md:w-1/2"
              inputProps={{
                name: "identity",
                tabIndex: 6,
                placeholder: "CPF ou Identificação",
                onChange: handleInputChange,
              }}
              icon={BiFingerprint}
              mask={{
                pattern: "### ### ### ### ###",
                allow: ["n*"],
              }}
            />
          </div>

          <p className="border-t border-zinc-300 pt-4 text-sm font-semibold">
            OPCIONAL:
          </p>
          <Inputfield
            icon={RiInstagramFill}
            width="full"
            inputProps={{
              name: "username",
              onChange: handleInputChange,
              tabIndex: 7,
              placeholder: "Instagram",
            }}
          />
        </div>
      </Step>

      <div className="mt-4 flex justify-between">
        <button
          type="button"
          onClick={UnsavedDialog}
          className="flex items-center space-x-2 rounded bg-zinc-100 px-4 py-2 text-sm font-semibold text-black disabled:cursor-not-allowed disabled:opacity-50"
        >
          <BiX />
          <p>CANCELAR</p>
        </button>
        <button
          type="submit"
          className="flex items-center space-x-2 rounded bg-primary-500 px-4 py-2 text-sm font-semibold text-white disabled:cursor-not-allowed disabled:opacity-50"
        >
          <MdPersonAdd />
          <p>{found ? "VINCULAR" : "CADASTRAR"} ALUNO</p>
        </button>
      </div>
    </form>
  );
};

export default CreateForm;
